import React from 'react';
import Radium from 'radium';
import {A} from 'views/AppElements';

class AdminDashboardTabs extends React.Component {

    render() {
        const activeTab = this.props.active;
        
        const orderTabClassName = (activeTab === "orders")? 'active-admin-tab': 'inactive-admin-tab';
        const stockTabClassName = (activeTab === "stocks")? 'active-admin-tab': 'inactive-admin-tab';
        const productTabClassName = (activeTab === "products")? 'active-admin-tab': 'inactive-admin-tab';
        const userTabClassName = (activeTab === "users")? 'active-admin-tab': 'inactive-admin-tab';

        return <div>
            <div className="flexRow adminTabs">
                <A href="/order/dashboard" className={orderTabClassName}>Orders</A>
                <A href="/stock/dashboard" className={stockTabClassName}>Stocks</A>
                <A href="/product/dashboard" className={productTabClassName}>Products</A>
                <A href="/all-users/dashboard" className={userTabClassName}>Users</A>
            </div>
            {this.props.children}
        </div>
    }
}


export default Radium(AdminDashboardTabs);



// WEBPACK FOOTER //
// ./src/views/admin/AdminDashboardTabs.js